import { useState, useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';

import { Auth } from './Common/lib/auth';

const AdminRoute = ({ component: Component, ...rest }) => {
    const [isAdmin, setIsAdmin] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const checkAdminStatus = async () => {
        try {
            const session = await Auth.currentSession();
            const isStaff = session.getAccessToken().payload.is_staff;
            setIsAdmin(isStaff === true || isStaff === 'true');
        } catch (error) {
            console.error('Error checking admin status:', error);
            setIsAdmin(false);
        }
        setIsLoading(false);
    };

    useEffect(() => {
        checkAdminStatus();
    }, []);

    return (
        <Route {...rest} render={(props) => (
            isLoading
                ? <div>Loading...</div>
                : isAdmin
                    ? <Component {...props} />
                    : <Redirect to="/" />
        )} />
    );
};

export default AdminRoute;